var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "home" }, [
    _c("div", { staticClass: "top-fixed" }, [_c("Navbar"), _c("LinkBar")], 1),
    _c("div", { staticClass: "flex-row content" }, [
      _c(
        "div",
        { staticClass: "flex-col flex-1 mb-3" },
        [_c("router-view")],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }